// Vue Directives
function input_delay_helper (fn, delay) {
    var timeoutID = null;
    return function () {
        clearTimeout(timeoutID);
        var args = arguments;
        var that = this;
        timeoutID = setTimeout(function () { fn.apply(that, args) }, delay);
    }
}

const filterNumberInput = function (e) {
    if (e.key === 'e') return e.preventDefault();
};

const preventWheel = function (e) {
    e.preventDefault();
};

export default {
    disable_wheel: {
        beforeMount: function (el) {
            el.addEventListener('wheel', preventWheel, { passive: false });
        },
        beforeUnmount: function (el) {
            el.removeEventListener('wheel', preventWheel);
        },
    },
    numbers: {
        beforeMount: function (el) {
            el.addEventListener('keydown', filterNumberInput);
        },
        beforeUnmount: function(el) {
            el.removeEventListener('keydown', filterNumberInput);
        }
    },
    input_delay: {
        beforeMount: function (el, binding) {
            el.oninput = input_delay_helper(function (evt) { 
                el.dispatchEvent(new Event('change')) 
            }, parseInt(binding.value) || 5000);
        },
        updated: function (el, binding) {
            if (binding.value !== binding.oldValue) {
                el.oninput = input_delay_helper(function (evt) { 
                    el.dispatchEvent(new Event('change')) 
                }, parseInt(binding.value) || 5000);
            }
        }
    },
};
